import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setDataLayout,
  setDataTheme,
} from "../../data/redux/themeSettingSlice";
import {
  setExpandMenu,
  setMobileSidebar,
  toggleMiniSidebar,
} from "../../data/redux/sidebarSlice";
import { useContext, useEffect, useRef, useState } from "react";
import { all_routes } from "../../../feature-module/router/all_routes";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../feature-module/UserPermissionsContext";
import React from "react";
import CommonSelect from "../commonSelect";
import { useCallContext } from "../../../feature-module/academic/examinations/CallContext";
import { Button, Card, Form } from "react-bootstrap";
import { InactivityContext } from "../../../feature-module/academic/examinations/InactivityContext";
import ImageWithBasePath from "../imageWithBasePath";

type PhotoType = {
  photo: string;
};

type StatusType = "Available" | "Break" | "On Call";

const Header = () => {
  const routes = all_routes;
  const dispatch = useDispatch();
  const dataTheme = useSelector((state: any) => state.themeSetting.dataTheme);
  const dataLayout = useSelector((state: any) => state.themeSetting.dataLayout);
  const navigate = useNavigate();
  const { userData, webApi, userProfile } = useUserPermissions();
  const jwtToken = Cookies.get("authToken");
  const [notificationVisible, setNotificationVisible] = useState(false);
  const [photo1, setPhoto1] = useState<PhotoType>({ photo: "" });
  const [status, setStatus] = useState("Available"); // Default status
  const [showCard, setShowCard] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState<string>("");
  const [selectedStatus1, setSelectedStatus1] = useState<string>("");
  const [showReasonCard, setShowReasonCard] = useState(false);
  const [reason, setReason] = useState("");
  const [showTimerCard, setShowTimerCard] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const [saleRankGroup, setSaleRankGroup] = useState('');
  const inactivityContext = useContext(InactivityContext);
  if (!inactivityContext) {
    throw new Error("Header must be used within an InactivityProvider");
  }
  const { isIdle, isStatusChange, setIsStatusChange, setIsprofileChange, isProfileChange } = inactivityContext;

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  useEffect(() => {
    fetch(`${webApi}/teammgmt/get_user_sale_rank_group/`, options)
      .then(response => response.json())
      .then(data => {
        // Adjust depending on response structure
        // Assuming: { sale_rank_group_name: "Elite" }
        setSaleRankGroup(data.sale_rank_group_name);
      })
      .catch(error => {
        console.error('Error fetching sale rank group:', error);
      });
  }, []);

  useEffect(() => {
    if (status === "Work Assign" || status === "Break" || status === "Idle Time") {
      setShowTimerCard(true);
    }
  });

  const fetchStatus = async () => {
    try {
      const response = await fetch(
        `${webApi}/user_monitoring/current_user_monitoring_status/`,
        options
      );
      const data = await response.json();
      setStatus(data.status_name); // Set the status from the response
      setSelectedStatus(data.status_name);

      if (data.status_name === "Available") {
        setShowTimerCard(false);
      }

      if (data.status_name === "Offline") {
        Cookies.remove("authToken");
        navigate("/login");
      }

      if (
        (data.status_name === "Break" || data.status_name === "Work Assign" || data.status_name === "Idle Time") &&
        data.updated_at
      ) {
        const updatedAt = new Date(data.updated_at).getTime(); // Convert to timestamp (milliseconds)
        const now = Date.now(); // Current timestamp
        const diffInSeconds = Math.floor((now - updatedAt) / 1000); // Calculate elapsed time in seconds
        setSeconds(diffInSeconds); // Set timer based on elapsed time
      }
      if (
        (data.status_name === "Idle Time") &&
        data.updated_at
      ) {
        const updatedAt = new Date(data.updated_at).getTime(); // Convert to timestamp (milliseconds)
        const now = Date.now(); // Current timestamp
        const diffInSeconds = Math.floor((now - updatedAt) / 1000); // Calculate elapsed time in seconds
        setSeconds(diffInSeconds + 300); // Set timer based on elapsed time
      }
    } catch (error) {
      console.error("Error fetching status:", error);
    } finally {
      // Ensure isStatusChange is set to false after fetching status
      setIsStatusChange(false);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      fetchStatus();
    }, 7000); // Fetch every 3 seconds

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, [isStatusChange]);

  useEffect(() => {
    const updateStatus = async () => {
      if (isIdle && status === "Available" && userProfile.is_idealtime) {
        await fetch(`${webApi}/user_monitoring/change_agent_status/6/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify({}), // Empty JSON object (not a string)
        });
        setStatus("Idle Time");
        setShowTimerCard(true);
        setSeconds(300);
        setSelectedStatus("Idle Time")
      } else {
        // setStatus("Available");
      }
    };

    updateStatus();
  }, [isIdle]);

  const mobileSidebar = useSelector(
    (state: any) => state.sidebarSlice.mobileSidebar
  );
  const [photo, setPhoto] = useState<File | null>(null);
  const { isCalling } = useCallContext();
  const toggleMobileSidebar = () => {
    dispatch(setMobileSidebar(!mobileSidebar));
  };

  const handleSubmitReason = async () => {
    if (!reason.trim()) {
      alert("Please enter a reason for the break.");
      return;
    }

    try {
      let apiUrl = `${webApi}/user_monitoring/change_agent_status/4/`;
      if (selectedStatus1 === "Work Assign") {
        apiUrl = `${webApi}/user_monitoring/change_agent_status/5/`;
      }
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
        body: JSON.stringify({ reason }),
      });

      if (response.ok) {
        setShowReasonCard(false);
        setShowTimerCard(true);
        setStatus("Break");
        if (selectedStatus === "Work Assign") {
          setStatus("Work Assign");
        }
        setSeconds(0); // Reset timer
        setReason("");
      } else {
        alert("Failed to update status.");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      alert("An error occurred");
    }
  };

  const handleReadyClick = async () => {
    try {
      const response = await fetch(
        `${webApi}/user_monitoring/change_agent_status/1/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify({}),
        }
      );

      if (response.ok) {
        setStatus("Available");
        setShowTimerCard(false);

        // Clear the timer properly
        if (timerRef.current) {
          clearInterval(timerRef.current);
          timerRef.current = null;
        }
        setSeconds(0); // Reset timer
      } else {
        alert("Failed to update status.");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      alert("An error occurred");
    }
  };

  useEffect(() => {
    if (showTimerCard) {
      timerRef.current = setInterval(() => {
        setSeconds((prev) => prev + 1);
      }, 1000);
    } else {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    }

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [showTimerCard]);

  useEffect(() => {
    if (isCalling) {
      setStatus("On Call");
    } else {
      setStatus("Available");
    }
  }, [isCalling]);

  const statusOptions = {
    Available: "green",
    Break: "black",
    "On Call": "red",
    "Work Assign": "blue",
    "Idle Time": "purple",

  };

  const onMouseEnter = () => {
    dispatch(setExpandMenu(true));
  };
  const onMouseLeave = () => {
    dispatch(setExpandMenu(false));
  };
  const handleToggleMiniSidebar = () => {
    if (dataLayout === "mini_layout") {
      dispatch(setDataLayout("default_layout"));
      localStorage.setItem("dataLayout", "default_layout");
    } else {
      dispatch(toggleMiniSidebar());
    }
  };

  const handleStatusClick = (
    statusKey: React.SetStateAction<string> | React.SetStateAction<null>
  ) => {
    if (statusKey === "Break" || statusKey === "Work Assign") {
      setShowReasonCard(true);
      setSelectedStatus(statusKey);
      setSelectedStatus1(statusKey);
      closeDropdown();
    } else {
      setStatus(statusKey as string);
      closeDropdown();
    }
  };

  const toggleNotification = () => {
    setNotificationVisible(!notificationVisible);
  };

  const handleLogout = () => {
    localStorage.removeItem("dateRange");
    Cookies.remove("authToken");
    navigate("/");
  };

  const handleToggleClick = () => {
    if (dataTheme === "default_data_theme") {
      dispatch(setDataTheme("dark_data_theme"));
    } else {
      dispatch(setDataTheme("default_data_theme"));
    }
  };

  const location = useLocation();

  const [isFullscreen, setIsFullscreen] = useState(false);
  const toggleFullscreen = () => {
    if (!isFullscreen) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen().catch((err) => { });
        setIsFullscreen(true);
      }
    } else {
      if (document.exitFullscreen) {
        if (document.fullscreenElement) {
          document.exitFullscreen().catch((err) => { });
        }
        setIsFullscreen(false);
      }
    }
  };

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  const handleProfileClick = () => {
    // Implement profile click logic here
    console.log("Profile clicked");
  };

  const handleLogoutClick = async () => {
    await fetch(`${webApi}/user/logout/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({}), // Empty JSON object (not a string)
    });
    localStorage.removeItem("dateRange");
    Cookies.remove("authToken");
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };
  useEffect(() => {
    const handleClickOutside = (event: { target: any }) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closeDropdown();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  useEffect(() => {
    const fetchPhoto = async () => {
      try {
        const response = await fetch(
          `${webApi}/user/add_update_userprofile_by_user/`,
          options
        );
        if (!response.ok) {
          const errorData = await response.json();
          if (errorData.code === "token_not_valid") {
            navigate("/login");
          }
          throw new Error(errorData.detail || "Failed to fetch user data");
        }
        const data = await response.json();
        setPhoto1(data.data);
      } catch (error) {
      } finally {
        setIsprofileChange(false);
      }
    };

    fetchPhoto();
  }, [isProfileChange]);

  return (
    <>
      {/* Header */}
      <div className="header">
        {/* Logo */}
        <div className="header-left active"
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}>
          <Link
            to={routes.adminDashboard}
            className="logo logo-normal"
            // style={{
            //   width: "50px",
            //   display: "flex",
            //   alignItems: "center",
            //   whiteSpace: "nowrap",
            //   marginTop: 2,
            // }}
          >
            <img
              src="/assets/img/Youtube_CP%20copy%204@4x.png"
              alt="Logo"
              style={{width: "290px", height: "35px" }}
            />
            {/* <h1 style={{ margin: 1, fontSize: "26px" }}>Sri Chaitanya</h1> */}
          </Link>
        </div>
        {/* /Logo */}
        <Link
          id="mobile_btn"
          className="mobile_btn"
          to="#sidebar"
          onClick={toggleMobileSidebar}
        >
          <span className="bar-icon">
            <span />
            <span />
            <span />
          </span>
        </Link>
        <div className="header-user">
          <div className="nav user-menu">
            {/* Search */}
            <div className="nav-item nav-search-inputs me-auto">
              {/* <div className="top-nav-search">
                <Link to="#" className="responsive-search">
                  <i className="fa fa-search" />
                </Link>
                <form action="#" className="dropdown">
                  <div className="searchinputs" id="dropdownMenuClickable">
                    <input type="text" placeholder="Search" />
                    <div className="search-addon">
                      <button type="submit">
                        <i className="ti ti-command" />
                      </button>
                    </div>
                  </div>
                </form>
              </div> */}
            </div>
            {/* /Search */}
            <div className="d-flex align-items-center">
              {saleRankGroup === 'Elite' && (
                <span className="badge rounded-pill bg-soft-success me-5" style={{ fontSize: '1.0rem', padding: '0.6em 1em' }}>Elite</span>
              )}
              {saleRankGroup === 'Rapid Risers' && (

                <span className="badge rounded-pill bg-soft-warning me-5" style={{ fontSize: '1.0rem', padding: '0.6em 1em' }}>Rapid Risers</span>
              )}
              {saleRankGroup === 'Challengers' && (
                <span className="badge rounded-pill bg-soft-danger me-5" style={{ fontSize: '1.0rem', padding: '0.6em 1em' }}>Challengers</span>
              )}

              <div className="pe-1">
                {!location.pathname.includes("layout-dark") && (
                  <Link
                    onClick={handleToggleClick}
                    to="#"
                    id="dark-mode-toggle"
                    className="dark-mode-toggle activate btn btn-outline-light bg-white btn-icon me-1"
                  >
                    <i
                      className={
                        dataTheme === "default_data_theme"
                          ? "ti ti-moon"
                          : "ti ti-brightness-up"
                      }
                    />
                  </Link>
                )}
              </div>
              <div
                className={`pe-1 ${notificationVisible ? "notification-item-show" : ""
                  }`}
                id="notification_item"
              >
                <Link
                  onClick={toggleNotification}
                  to="#"
                  className="btn btn-outline-light bg-white btn-icon position-relative me-1"
                  id="notification_popup"
                >
                  <i className="ti ti-bell" />
                  <span className="notification-status-dot" />
                </Link>
                <div className="dropdown-menu dropdown-menu-end notification-dropdown p-4">
                  <div className="d-flex align-items-center justify-content-between border-bottom p-0 pb-3 mb-3">
                    <h4 className="notification-title">Notifications (2)</h4>
                    <div className="d-flex align-items-center">
                      <Link to="#" className="text-primary fs-15 me-3 lh-1">
                        Mark all as read
                      </Link>
                      <div className="dropdown">
                        <Link
                          to="#"
                          className="bg-white dropdown-toggle"
                          data-bs-toggle="dropdown"
                        >
                          <i className="ti ti-calendar-due me-1" />
                          Today
                        </Link>
                        <ul className="dropdown-menu mt-2 p-3">
                          <li>
                            <Link to="#" className="dropdown-item rounded-1">
                              This Week
                            </Link>
                          </li>
                          <li>
                            <Link to="#" className="dropdown-item rounded-1">
                              Last Week
                            </Link>
                          </li>
                          <li>
                            <Link to="#" className="dropdown-item rounded-1">
                              Last Week
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="noti-content">
                    <div className="d-flex flex-column">
                      <div className="border-bottom mb-3 pb-3">
                        <Link to={routes.activity}>
                          <div className="d-flex">
                            <span className="avatar avatar-lg me-2 flex-shrink-0">
                              <img
                                src="https://cdn-icons-png.flaticon.com/128/11918/11918393.png"
                                alt="User Profile"
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "50%",
                                  marginRight: "5px",
                                  cursor: "pointer",
                                }}
                              />
                            </span>
                            <div className="flex-grow-1">
                              <p className="mb-1">
                                <span className="text-dark fw-semibold">
                                  Shawn
                                </span>{" "}
                                performance in Math is below the threshold.
                              </p>
                              <span>Just Now</span>
                            </div>
                          </div>
                        </Link>
                      </div>
                      <div className="border-bottom mb-3 pb-3">
                        <Link to="" className="pb-0">
                          <div className="d-flex">
                            <span className="avatar avatar-lg me-2 flex-shrink-0">
                              <img
                                src="https://cdn-icons-png.flaticon.com/128/11918/11918393.png"
                                alt="User Profile"
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "50%",
                                  marginRight: "5px",
                                  cursor: "pointer",
                                }}
                              />
                            </span>
                            <div className="flex-grow-1">
                              <p className="mb-1">
                                <span className="text-dark fw-semibold">
                                  Sylvia
                                </span>{" "}
                                added appointment on 02:00 PM
                              </p>
                              <span>10 mins ago</span>
                              <div className="d-flex justify-content-start align-items-center mt-1">
                                <span className="btn btn-light btn-sm me-2">
                                  Deny
                                </span>
                                <span className="btn btn-primary btn-sm">
                                  Approve
                                </span>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                      <div className="border-bottom mb-3 pb-3">
                        <Link to={""}>
                          <div className="d-flex">
                            <span className="avatar avatar-lg me-2 flex-shrink-0">
                              <img
                                src="https://cdn-icons-png.flaticon.com/128/11918/11918393.png"
                                alt="User Profile"
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "50%",
                                  marginRight: "5px",
                                  cursor: "pointer",
                                }}
                              />
                            </span>
                            <div className="flex-grow-1">
                              <p className="mb-1">
                                New student record{" "}
                                <span className="text-dark fw-semibold">
                                  {" "}
                                  George
                                </span>{" "}
                                is created by{" "}
                                <span className="text-dark fw-semibold">
                                  Teressa
                                </span>
                              </p>
                              <span>2 hrs ago</span>
                            </div>
                          </div>
                        </Link>
                      </div>
                      <div className="border-0 mb-3 pb-0">
                        <Link to={routes.activity}>
                          <div className="d-flex">
                            <span className="avatar avatar-lg me-2 flex-shrink-0">
                              <img
                                src="https://cdn-icons-png.flaticon.com/128/11918/11918393.png"
                                alt="User Profile"
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "50%",
                                  marginRight: "5px",
                                  cursor: "pointer",
                                }}
                              />
                            </span>
                            <div className="flex-grow-1">
                              <p className="mb-1">
                                A new teacher record for{" "}
                                <span className="text-dark fw-semibold">
                                  Elisa
                                </span>
                              </p>
                              <span>09:45 AM</span>
                            </div>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex p-0">
                    <Link to="#" className="btn btn-light w-100 me-2">
                      Cancel
                    </Link>
                    <Link
                      to={routes.activity}
                      className="btn btn-primary w-100"
                    >
                      View All
                    </Link>
                  </div>
                </div>
              </div>
              <div className="pe-1">
                <Link
                  onClick={toggleFullscreen}
                  to="#"
                  className="btn btn-outline-light bg-white btn-icon me-1"
                  id="btnFullscreen"
                >
                  <i className="ti ti-maximize" />
                </Link>
              </div>

              <div className="d-flex align-items-center pe-1" ref={dropdownRef}>
                <img
                  src={
                    photo1.photo
                      ? `${webApi}${photo1.photo}`
                      : "https://cdn-icons-png.flaticon.com/128/11918/11918393.png"
                  }
                  alt="User Profile"
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    marginRight: "5px",
                    cursor: "pointer",
                    position: "relative",
                    boxShadow: `0 0 0 2px white, 0 0 0 4px ${statusOptions[status as keyof typeof statusOptions]
                      }`, // Green border for active status
                  }}
                  onClick={toggleDropdown}
                />

                {isDropdownOpen && (
                  <div
                    style={{
                      position: "absolute",
                      top: "50px",
                      right: "10px",
                      backgroundColor: "white",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      borderRadius: "5px",
                      zIndex: 1000,
                    }}
                    className="d-block"
                  >
                    <hr className="m-0" />
                    <Link
                      className="dropdown-item d-inline-flex align-items-center"
                      to={routes.profile}
                      onClick={closeDropdown}
                    >
                      <i className="ti ti-user-circle me-2" />
                      My Profile
                    </Link>
                    <hr className="m-0" />
                    {Object.keys(statusOptions)
                      .filter(
                        (option) =>
                          option === "Break" || option === "Work Assign"
                      ) // Only show "Break" option
                      .map((option) => {
                        const statusKey = option as keyof typeof statusOptions;
                        return (
                          <Link
                            key={statusKey}
                            className="dropdown-item d-inline-flex align-items-center"
                            to="#"
                            onClick={() => handleStatusClick(statusKey)}
                          >
                            <span
                              style={{
                                width: "8px",
                                height: "8px",
                                backgroundColor: statusOptions[statusKey],
                                borderRadius: "50%",
                                display: "inline-block",
                                marginRight: "5px",
                              }}
                            ></span>
                            {statusKey}
                          </Link>
                        );
                      })}

                    <hr className="m-0" />
                    <Link
                      className="dropdown-item d-inline-flex align-items-center"
                      to={routes.login2}
                      onClick={handleLogoutClick}
                    >
                      <i className="ti ti-login me-2" />
                      Logout
                    </Link>
                  </div>
                )}
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <h6
                    style={{
                      // marginBottom: "4px",
                      cursor: "pointer",
                      fontWeight: "bold",
                      textTransform: "lowercase",
                      fontSize: "19px",
                      marginLeft: "5px",
                      marginTop: "5px",
                    }}
                    onClick={toggleDropdown}
                  >
                    {userData?.username.toLowerCase()}
                  </h6>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "11px",
                        marginBottom: "0",
                        marginLeft: "5px",
                        color:
                          statusOptions[status as keyof typeof statusOptions],
                        cursor: "pointer",
                      }}
                      onClick={toggleDropdown}
                    >
                      {status}
                    </p>
                  </div>
                </div>
              </div>

              {/* <div>
                <button
                  style={{
                    backgroundColor: "lightcoral",
                    color: "white",
                  }}
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </div> */}
            </div>
          </div>
        </div>
        {showReasonCard && (
          <>
            {/* Full-Screen Overlay (Covers Sidebar Too) */}
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(1, 1, 1, 0.6)", // Dims everything
                // zIndex: 999, // Higher than the sidebar
              }}
            ></div>

            {/* Centered Modal/Card */}
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 100000, // Above overlay and sidebar
              }}
            >
              <Card
                className="p-3 shadow-lg"
                style={{ width: "400px", backgroundColor: "white" }}
              >
                <Card.Body>
                  <Card.Title style={{ marginBottom: "5px" }}>
                    Reason
                  </Card.Title>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      value={reason}
                      onChange={(e) => setReason(e.target.value)}
                      placeholder="Enter reason for break"
                      required
                    />
                  </Form.Group>
                  <div className="d-flex justify-content-end mt-3">
                    <Button
                      variant="secondary"
                      onClick={() => setShowReasonCard(false)}
                      className="me-2"
                    >
                      Cancel
                    </Button>
                    <Button variant="primary" onClick={handleSubmitReason}>
                      Submit
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </>
        )}

        {showTimerCard && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              // zIndex: 1040000,
            }}
          >
            <Card
              className="p-3 shadow-lg text-center"
              style={{ width: "400px", backgroundColor: "white", zIndex: 1050 }}
            >
              <Card.Body>
                <Card.Title>
                  {status === "Work Assign"
                    ? "Work Assigned Time"
                    : status === "Idle Time"
                      ? "Idle Time"
                      : "Break Time"}
                </Card.Title>

                <h2>
                  {Math.floor(seconds / 60)}:
                  {String(seconds % 60).padStart(2, "0")}
                </h2>
                <Button
                  variant="success"
                  className="mt-3"
                  onClick={handleReadyClick}
                >
                  Available
                </Button>
              </Card.Body>
            </Card>
          </div>
        )}

        {/* Mobile Menu */}
        <div className="dropdown mobile-user-menu">
          <Link
            to="#"
            className="nav-link dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-end">
            {/* <Link className="dropdown-item" to={routes.profile}>
              My Profile
            </Link>
            <Link className="dropdown-item" to={routes.profilesettings}>
              Settings
            </Link> */}
            <Link className="dropdown-item" onClick={handleLogout} to="#">
              Logout
            </Link>
          </div>
        </div>
        {/* /Mobile Menu */}
      </div>
      {/* /Header */}
    </>
  );
};

export default Header;
